import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../lib/language'

// Shared public-site footer (matches the locked homepage look).
export default function SiteFooter() {
  const { t } = useLanguage()

  const styles = `
    .nsv-footer { background:#E9EAEC; border-top:1px solid #D7D9DC; padding:34px 44px 30px; text-align:center; font-family:'Plus Jakarta Sans',-apple-system,BlinkMacSystemFont,system-ui,sans-serif; }
    .nsv-footer :focus-visible { outline:2px solid #4D4E8D; outline-offset:3px; border-radius:6px; }
    .nsv-footer-brand { display:inline-flex; align-items:center; gap:11px; text-decoration:none; margin-bottom:20px; }
    .nsv-footer-brand img { width:32px; height:32px; object-fit:contain; }
    .nsv-footer-name { font-size:15px; font-weight:700; color:#151715; display:block; text-align:left; letter-spacing:-.01em; }
    .nsv-footer-sub { font-size:9px; font-weight:600; letter-spacing:.14em; color:#8A8F94; margin-top:3px; display:block; text-align:left; }
    .nsv-footer-links { display:flex; gap:22px; justify-content:center; flex-wrap:wrap; margin-bottom:20px; }
    .nsv-footer-links a { font-size:13px; font-weight:500; color:#5C6065; text-decoration:none; transition:color .2s; }
    .nsv-footer-links a:hover { color:#4D4E8D; }
    .nsv-footer-bottom { border-top:1px solid #DEE0E3; padding-top:18px; }
    .nsv-footer-copy { font-size:12px; color:#8A8F94; margin-bottom:5px; }
    .nsv-footer-veteran { font-size:12px; font-weight:600; color:#5E8A72; letter-spacing:.03em; }
    .nsv-footer-legal { font-size:10px; color:#A2A6AA; margin-top:7px; }
    @media(max-width:520px){ .nsv-footer-links{ gap:14px; } }
  `

  return (
    <footer className="nsv-footer" role="contentinfo">
      <style>{styles}</style>
      <Link to="/" className="nsv-footer-brand" aria-label="Notary Signing Vault, LLC — Nationwide Notary Professionals Network — homepage">
        <img src="/nsv_emblem.png?v=2" alt="Notary Signing Vault, LLC logo" onError={e => { e.target.style.display = 'none' }} />
        <div>
          <span className="nsv-footer-name">Notary Signing Vault, LLC</span>
          <span className="nsv-footer-sub">NATIONWIDE NOTARY PROFESSIONALS NETWORK</span>
        </div>
      </Link>
      <nav className="nsv-footer-links" aria-label="Footer navigation">
        <Link to="/services">{t('footer_services')}</Link>
        <Link to="/about">{t('footer_about')}</Link>
        <Link to="/contact">{t('footer_contact')}</Link>
        <Link to="/accessibility">{t('footer_accessibility')}</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/login">{t('footer_signin')}</Link>
      </nav>
      <div className="nsv-footer-bottom">
        <div className="nsv-footer-copy">{t('footer_copy')}</div>
        <div className="nsv-footer-veteran">{t('footer_veteran')}</div>
        <div className="nsv-footer-legal">Notary Signing Vault, LLC is not a law firm and does not provide legal advice.</div>
      </div>
    </footer>
  )
}
